'use strict';

module.exports = {

    getUrl() {
        return Odigeo.Settings.getProperty('recaptchaUrlFormatter')('getRecaptchaSiteKey');
    },

    getMethod: Odigeo._.constant('GET'),

};
